<template>
    <div :id="`lm-form-subtitles-builder-ui-${id}`" class="row">
      <LmTextInput
        :id="`label-${id}`"
        class="col-12 col-md-4"
        v-model="component.componentProps.text"
        @input="$emit('input', component)"
        label="Label"
        placeholder="Label"
      />
      <LmTextInput
        :id="`css-class-${id}`"
        class="col-12 col-md-4"
        v-model="component.class"
        @input="$emit('input', component)"
        label="Css Class"
        placeholder="col-12"
      />
      <LmConditionalBuilderUi
        v-if="isVisibleCondition"
        class="col-12"
        :id="String(id)"
        :leftValueToCompareOptions="leftValueToCompareOptions"
        :visibilityDependOnConditions="visibilityDependOnConditions"
        @changeVisibilityDependOnConditions="component.visibilityDependOnConditions = $event"
        @input="$emit('input', component)"
        />
    </div>
</template>

<script>
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmConditionalBuilderUi from '@/components/lmFormBuilderUi/LmConditionalBuilderUi'
export default {
  data () {
    return {
      component: {
        class: 'col-12 mt-3',
        componentName: 'LmFormSubtitles',
        componentProps: {
          text: 'Otro subtítulo'
        }
      }
    }
  },
  components: {
    LmTextInput,
    LmConditionalBuilderUi
  },
  props: {
    isVisibleCondition: {
      type: Boolean,
      default: true
    },
    visibilityDependOnConditions: {
      type: Object,
      default: () => ({
        isActive: false,
        conditions: []
      })
    },
    leftValueToCompareOptions: {
      type: Object,
      default: () => ({
        disabledOption: '',
        content: []
      })
    },
    id: {
      type: [String, Number],
      default: ''
    },
    componentData: {
      type: Object,
      default: () => (
        {
          class: 'col-12 mt-3',
          componentName: 'LmFormSubtitles',
          componentProps: {
            text: 'Otro subtítulo'
          }
        }
      )
    }
  },
  created () {
    this.component = this.componentData
  }
}
</script>
